import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsAnalyticsDataViewCreateRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-analytics-data-view-create',
	path: '/jira/servicedesk/assets/analytics/data-view/create',
	exact: true,
};
